"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = exports.NOTIFICATION_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = require("../../utils/classify");
var _Icon = require("../Icon");
var _Text = require("../Text");
var _NotificationModule = _interopRequireDefault(require("./Notification.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const NOTIFICATION_SEMANTIC = exports.NOTIFICATION_SEMANTIC = Object.freeze({
  success: 'success',
  information: 'information',
  danger: 'danger'
});
// Base Notification will not have any state.

const BaseNotification = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    classNames,
    semantic = NOTIFICATION_SEMANTIC.success,
    iconLeftName,
    iconLeftType = 'regular',
    dismissable,
    children,
    onCloseClick
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_NotificationModule.default.baseContainer, {
      [_NotificationModule.default.success]: semantic === NOTIFICATION_SEMANTIC.success,
      [_NotificationModule.default.information]: semantic === NOTIFICATION_SEMANTIC.information,
      [_NotificationModule.default.danger]: semantic === NOTIFICATION_SEMANTIC.danger,
      [_NotificationModule.default.dismissable]: dismissable
    }, classNames?.wrapper),
    ref: ref
  }, iconLeftName ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconLeftName,
    color: _typography.TEXT_COLORS.inversePrimary,
    size: "small",
    type: iconLeftType
  }) : null, /*#__PURE__*/React.createElement(_Text.SubTitleSmall, {
    className: (0, _classify.classify)(classNames?.text),
    color: _typography.TEXT_COLORS.inversePrimary
  }, children), dismissable && /*#__PURE__*/React.createElement(_Icon.Icon, {
    color: _typography.TEXT_COLORS.inversePrimary,
    name: "close",
    size: "small",
    type: "regular",
    onClick: onCloseClick,
    className: _NotificationModule.default.closeIcon
  }));
});
const Notification = exports.Notification = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    classNames,
    semantic = NOTIFICATION_SEMANTIC.success,
    iconLeftName,
    iconLeftType,
    dismissable,
    children,
    // @ts-ignore - TS2339 - Property 'selfDismiss' does not exist on type 'NotificationProps'.
    selfDismiss = false,
    onCloseClick
  } = props;
  const [dismissed, setDismissed] = React.useState(false);
  const closeClickHandler = e => {
    onCloseClick && onCloseClick(e);
    selfDismiss && setDismissed(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !dismissed && /*#__PURE__*/React.createElement(BaseNotification, {
    classNames: classNames,
    iconLeftName: iconLeftName,
    iconLeftType: iconLeftType,
    semantic: semantic,
    dismissable: dismissable,
    onCloseClick: closeClickHandler,
    ref: ref
  }, children));
});